import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item"];
  static values = {
    existingItems: Array
  }

  declare readonly inputTarget: HTMLInputElement;
  declare readonly itemTargets: HTMLElement[];
  declare readonly existingItemsValue: string[];

  private selected: Set<string> = new Set();
  private rangeStart: string | null = null;
  private existingItems: Set<string> = new Set();

  connect(): void {
    this.existingItems = new Set(this.existingItemsValue);
    this.selected = new Set(this.existingItemsValue);
    this.updateInput();
    this.updateAllVisuals();
  }

  toggle(event: Event): void {
    const item = event.currentTarget as HTMLElement;
    const value = item.dataset.value;
    const selectable = item.dataset.selectable !== "false";
    const isMuted = item.classList.contains('range-selector-item--muted');

    if (!value || !selectable || isMuted) {
      return;
    }

    if (this.selected.has(value)) {
      this.selected.delete(value)
    } else {
      this.selected.add(value)
    }

    this.updateInput();
    this.updateAllVisuals();
  }

  clearAll(): void {
    this.selected.clear();
    this.updateInput();
    this.updateAllVisuals();
  }

  reset(): void {
    this.selected = new Set(this.existingItems);
    this.updateInput();
    this.updateAllVisuals();
  }

  private updateAllVisuals(): void {
    this.itemTargets.forEach(item => {
      const value = item.dataset.value;
      if (value) {
        // Clear all state classes
        item.classList.remove(
          "range-selector-item--existing-selected",
          "range-selector-item--new-selected",
          "range-selector-item--existing-deselected"
        );

        const isSelected = this.selected.has(value);
        const wasExisting = this.existingItems.has(value);

        if (isSelected && wasExisting) {
          item.classList.add("range-selector-item--existing-selected");
        } else if (isSelected && !wasExisting) {
          item.classList.add("range-selector-item--new-selected");
        } else if (!isSelected && wasExisting) {
          item.classList.add("range-selector-item--existing-deselected");
        }
      }
    });
  }

  private updateInput(): void {
    this.inputTarget.value = Array.from(this.selected).sort().join(',');
  }
}